export const ENROLLMENT_LOOKUP = {
  windows: {
    label: "Windows",
    hostname:
      "Settings → System → About → Device name, or run this in PowerShell or Command Prompt:",
    hostnameCmd: "hostname",
    serial: "In PowerShell, run:",
    serialCmd:
      "Get-CimInstance Win32_BIOS | Select-Object -ExpandProperty SerialNumber",
    serialAlt: "On older Windows, this still works:",
    serialAltCmd: "wmic bios get serialnumber",
  },
  linux: {
    label: "Linux",
    hostname: "Open a terminal and run:",
    hostnameCmd: "hostname",
    serial: "Open a terminal and run (may ask for your password):",
    serialCmd: "sudo dmidecode -s system-serial-number",
    serialAlt: "If dmidecode is not installed:",
    serialAltCmd: "cat /sys/class/dmi/id/product_serial",
  },
  macos: {
    label: "macOS",
    hostname:
      "Apple menu → System Settings → General → Sharing → Computer Name, or run this in Terminal:",
    hostnameCmd: "scutil --get ComputerName",
    serial: "Apple menu → About This Mac, or run this in Terminal:",
    serialCmd:
      "system_profiler SPHardwareDataType | awk '/Serial Number/{print $NF}'",
  },
}

export const lookupForOs = (osPlatform) =>
  ENROLLMENT_LOOKUP[osPlatform] || ENROLLMENT_LOOKUP.windows
